module.exports = __webpack_public_path__ + "img/25.c62f8f7c.png";